exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\n    margin-top: 8px;\n}\n\nh3 {\n    margin-top: 8px;\n}\n\nh4 {\n    margin-bottom: 16px;\n}\n\n.marginTop {\n    margin-top: 16px;\n}\n\n.normalBox {\n    border: 3px solid rgba(100, 100, 100, 0.918);\n    border-top: 1px solid rgba(100, 100, 100, 0.918);\n    border-bottom: 1px solid rgba(100, 100, 100, 0.918);\n    padding: 10px;\n    border-radius: 8px;\n}\n\n.paragraphSeparator {\n    margin-top: 1rem;\n}\n\n.noBottomMargin {\n    margin-bottom: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/src/app/blog.css
// module id = ../../../../../src/app/blog.css
// module chunks = main